import { useEffect, useState } from 'react';
/**
 * Returns a debounced copy of `value` that updates only after `delayMs`
 * have elapsed without further changes.
 */
export function useDebounce(value, delayMs = 250) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const t = setTimeout(() => setDebounced(value), delayMs);
        return () => clearTimeout(t);
    }, [value, delayMs]);
    return debounced;
}
//# sourceMappingURL=useDebounce.js.map